<template>
  <div class="app-container">
    <div class="page-title" style="display:flex;flex-direction:row;align-items:center;gap:8px">
      <h2>{{ $t('scoop.scoops') }}</h2>
      <h2>🏢</h2>
    </div>

    <el-row :gutter="40" class="panel-group">
      <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description" style="display:flex;flex-direction:row;align-items:center;gap:8px">
            <div class="card-panel-text">Total scoops :</div> (
            <count-to :start-val="0" :end-val="list ? list.length : 0" :duration="2600" class="card-panel-num" />)
          </div>
        </div>
      </el-col>
    </el-row>

    <el-card v-if="checkRole(['admin'])" class="box-card filter-card just-for-admin">
      <div slot="header" class="clearfix">
        <span>{{ $t('general.filter') }}</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="initSearch">{{ $t('general.init') }}</el-button>
      </div>
      <div class="filter-container">
        <el-radio v-model="activeList" label="desactives" border @change="handleFilterScoops">{{ $t('general.F_desactives') }}</el-radio>
        <el-radio v-model="activeList" label="disponibles" border @change="handleFilterScoops">{{ $t('general.disponibles') }}</el-radio>
        <el-radio v-model="activeList" label="corbeille" class="danger-radio" border @change="handleFilterScoops">{{ $t('general.corbeille') }}</el-radio>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input
          v-model="query.keyword"
          :placeholder="$t('general.keyword')"
          class="wd-200 mr-15 filter-item"
          @keyup.enter.native="handleFilterScoops"
          @input="handleFilterScoops"
        />
        <el-button v-waves class="mr-15 filter-item" type="primary" icon="el-icon-search" @click="handleFilterScoops">
          {{ $t('general.search') }}
        </el-button>
        <el-button v-waves :loading="downloading" class="filter-item" type="primary" icon="el-icon-download" @click="handleDownload">
          {{ $t('general.export') }}
        </el-button>
        <el-button v-if="checkPermission(['creer scoop'])" class="mr-15 filter-item" type="primary" icon="el-icon-plus" @click="handlecreateScoop">
          {{ $t('general.add') }}
        </el-button>
      </div>

      <el-table v-loading="loading" :data="list" border fit highlight-current-row style="width: 100%">
        <el-table-column align="center" label="Code" min-width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('general.nom')" min-width="200px">
          <template slot-scope="scope">
            <span>{{ scope.row.nom }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('general.description')" min-width="250px">
          <template slot-scope="scope">
            <span>{{ scope.row.description }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('scoop.superviseur')" min-width="220px">
          <template slot-scope="scope">
            <span v-if="scope.row.responsable">{{ scope.row.responsable.nom }} {{ scope.row.responsable.prenom }}</span>
            <span v-else-if="scope.row.controleur_responsable">{{ scope.row.controleur_responsable.nom }} {{ scope.row.controleur_responsable.prenom }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="UP" min-width="120px">
          <template slot-scope="scope">
            <el-tag type="info">{{ scope.row.unites_production_count || (scope.row.unites_production ? scope.row.unites_production.length : 0) || 0 }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="Noms UP" min-width="250px">
          <template slot-scope="scope">
            <el-tag v-for="up in scope.row.unites_production" :key="up.id" type="success" style="margin-right: 5px; margin-bottom: 5px;">
              {{ up.nom }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column v-if="checkPermission(['activer scoop'])" align="center" :label="$t('general.status')" width="120">
          <template slot-scope="scope">
            <el-switch
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_active"
              @change="setScoopStatus(scope.row.id, 'active')"
            />
          </template>
        </el-table-column>

        <el-table-column v-if="checkRole(['admin']) && (activeList==='corbeille' || query.keyword)" align="center" :label="$t('general.restaurer')" width="120">
          <template slot-scope="scope">
            <el-switch
              v-if="!scope.row.is_visible"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_visible"
              @change="setScoopStatus(scope.row.id, 'visible')"
            />
          </template>
        </el-table-column>

        <el-table-column v-if="checkPermission(['modifier scoop','supprimer scoop','visible scoop'])" align="center" :label="$t('general.actions')" width="200">
          <template slot-scope="scope">
            <el-button v-if="scope.row.is_visible && checkPermission(['modifier scoop'])" type="primary" size="small" icon="el-icon-edit" @click="handleEditScoop(scope.row.id)" />
            <el-button v-if="checkPermission(['visible scoop','supprimer scoop'])" type="danger" size="small" icon="el-icon-delete" @click="handleDeleteScoop(scope.row.id, scope.row.is_visible, scope.row.nom)" />
            <el-button type="info" size="small" icon="el-icon-view" @click="showDetailsPage(scope.row.id)" />
          </template>
        </el-table-column>
      </el-table>

      <pagination v-if="total > query.limit" :total="total" :page.sync="query.page" :limit.sync="query.limit" @pagination="getScoopsList" />

      <el-dialog
        :title="editing ? $t('scoop.edit') + ' ' + currentScoop.nom : $t('scoop.AddScoop')"
        :visible.sync="dialogCreateScoop"
        width="40%"
      >
        <el-form ref="scoopForm" :model="currentScoop" :rules="rules" label-position="left" label-width="140px">
          <el-form-item :label="$t('scoop.code')" prop="code">
            <el-input v-model="currentScoop.code" maxlength="10" show-word-limit />
          </el-form-item>
          <el-form-item :label="$t('scoop.nom')" prop="nom">
            <el-input v-model="currentScoop.nom" maxlength="100" show-word-limit />
          </el-form-item>
          <el-form-item :label="$t('scoop.description')" prop="description">
            <el-input v-model="currentScoop.description" type="textarea" :rows="3" />
          </el-form-item>
          <el-form-item :label="$t('scoop.superviseur')" prop="responsable_id">
            <el-select
              v-model="currentScoop.responsable_id"
              filterable
              remote
              reserve-keyword
              :remote-method="remoteSuperviseurSearch"
              :loading="loadingSuperviseurs"
              style="width:100%"
              placeholder="Superviseur"
            >
              <el-option
                v-for="sup in superviseurs"
                :key="sup.id"
                :label="sup.nom + ' ' + sup.prenom"
                :value="sup.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="checkPermission(['activer scoop'])" :label="$t('general.status')" prop="is_active">
            <el-switch v-model="currentScoop.is_active" />
          </el-form-item>
          <el-form-item v-if="checkRole(['admin'])" :label="$t('general.visible')" prop="is_visible">
            <el-switch v-model="currentScoop.is_visible" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button plain type="danger" @click="dialogCreateScoop=false">{{ $t('general.cancel') }}</el-button>
          <el-button type="primary" :loading="saving" @click="editing ? updateScoop() : createScoop()">
            {{ saving ? $t('general.saving') : $t('general.save') }}
          </el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import waves from '@/directive/waves';
import permission from '@/directive/permission';
import role from '@/directive/role';
import checkPermission from '@/utils/permission';
import checkRole from '@/utils/role';
import CountTo from 'vue-count-to';
import scoopApi from '@/api/scoop';
import Resource from '@/api/resource';

const controleurResource = new Resource('controleurs');

export default {
  name: 'ScoopsList',
  components: { Pagination, CountTo },
  directives: { waves, permission, role },
  data() {
    return {
      list: [],
      total: 0,
      loading: true,
      downloading: false,
      activeList: 'disponibles',
      dialogCreateScoop: false,
      editing: false,
      saving: false,
      currentScoop: {},
      currentScoopId: null,
      query: {
        page: 1,
        limit: this.$limit || 20,
        keyword: '',
      },
      rules: {
        nom: [{ required: true, message: this.$t('scoop.NomRequired'), trigger: 'blur' }],
      },
      superviseurs: [],
      loadingSuperviseurs: false,
    };
  },
  created() {
    this.resetNewScoop();
    this.getScoopsList();
    this.fetchSuperviseurs();
  },
  methods: {
    checkPermission,
    checkRole,
    async getScoopsList() {
      this.loading = true;
      try {
        let data = [];
        let meta = {};
        if (this.activeList === 'desactives') {
          const resp = await scoopApi.sublist('indexdesactive', this.query);
          data = resp.data || [];
          meta = resp.meta || {};
        } else if (this.activeList === 'corbeille') {
          const resp = await scoopApi.sublist('indexinvisible', this.query);
          data = resp.data || [];
          meta = resp.meta || {};
        } else {
          const resp = await scoopApi.sublist('indexactive', this.query);
          data = resp.data || [];
          meta = resp.meta || {};
        }
        this.list = data || [];
        this.total = meta && meta.total ? meta.total : (data ? data.length : 0);
      } finally {
        this.loading = false;
      }
    },
    handleFilterScoops() {
      this.query.page = 1;
      this.getScoopsList();
    },
    initSearch() {
      this.query.keyword = '';
      this.activeList = 'disponibles';
      this.getScoopsList();
    },
    showDetailsPage(id) {
      this.$router.push({ path: '/scoop/' + id });
    },
    handlecreateScoop() {
      this.editing = false;
      this.resetNewScoop();
      this.dialogCreateScoop = true;
      this.$nextTick(() => this.$refs.scoopForm && this.$refs.scoopForm.clearValidate());
    },
    handleEditScoop(id) {
      this.editing = true;
      this.resetNewScoop();
      const found = this.list.find(item => item.id === id);
      if (found) {
        this.currentScoop = { ...found, responsable_id: found.responsable_id || (found.responsable ? found.responsable.id : null) };
        this.currentScoopId = id;
      }
      this.dialogCreateScoop = true;
      this.$nextTick(() => this.$refs.scoopForm && this.$refs.scoopForm.clearValidate());
    },
    handleDeleteScoop(id, visible, nom) {
      this.$confirm(this.$t('scoop.deleteWarn') + ' ' + nom + '. ' + this.$t('general.deleteContinue'), 'Warning', {
        confirmButtonText: this.$t('general.ouiSupprimer') || 'Oui',
        cancelButtonText: this.$t('general.cancel'),
        type: 'warning',
      }).then(() => {
        if (!visible && (checkRole(['admin']) || checkPermission(['supprimer scoop']))) {
          this.$swal({
            title: this.$t('general.SureQuestion'),
            text: this.$t('general.irrversibleMessage'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('general.ouiSupprimer'),
          }).then((result) => {
            if (result.isConfirmed) {
              scoopApi.destroy(id).then(() => {
                this.$message({ type: 'success', message: this.$t('scoop.suppressionEffectue') });
                this.getScoopsList();
              });
            }
          });
        } else {
          this.setScoopStatus(id, 'visible');
        }
      }).catch(() => {
        this.$message({ type: 'info', message: this.$t('general.suppressionAnnule') });
      });
    },
    createScoop() {
      this.$refs.scoopForm.validate(async(valid) => {
        if (!valid) {
          return;
        }
        this.saving = true;
        try {
          await scoopApi.store(this.currentScoop);
          this.$message({ message: this.$t('scoop.NewScoop') + ' ' + this.currentScoop.nom + ' ' + this.$t('scoop.iscreatedSuccessfully'), type: 'success' });
          this.dialogCreateScoop = false;
          this.getScoopsList();
        } finally {
          this.saving = false;
        }
      });
    },
    updateScoop() {
      this.$refs.scoopForm.validate(async(valid) => {
        if (!valid) {
          return;
        }
        this.saving = true;
        try {
          await scoopApi.update(this.currentScoopId, this.currentScoop);
          this.$message({ message: this.$t('scoop.nom') + ' ' + this.currentScoop.nom + ' ' + this.$t('scoop.isupdatedSuccessfully'), type: 'success' });
          this.dialogCreateScoop = false;
          this.getScoopsList();
        } finally {
          this.saving = false;
        }
      });
    },
    async setScoopStatus(id, type) {
      const { success } = await scoopApi.toggleStatus(id, type);
      if (success !== false) {
        this.$message({ type: 'success', message: this.$t('general.statusUpdated') });
        this.getScoopsList();
      } else {
        this.$message({ type: 'error', message: this.$t('general.statusUpdateError') });
      }
    },
    resetNewScoop() {
      this.currentScoop = {
        code: '',
        nom: '',
        description: '',
        responsable_id: null,
        is_active: true,
        is_visible: true,
      };
      this.currentScoopId = null;
    },
    async handleDownload() {
      this.downloading = true;
      try {
        const { export_json_to_excel } = await import('@/vendor/Export2Excel');
        const tHeader = ['Code', this.$t('general.nom'), this.$t('general.description'), this.$t('scoop.superviseur'), 'UP', 'Noms UP', this.$t('general.status')];
        const filterVal = ['code', 'nom', 'description', 'superviseur', 'upCount', 'upNames', 'is_active'];
        const data = this.list.map(item => ({
          code: item.code,
          nom: item.nom,
          description: item.description,
          superviseur: item.responsable ? `${item.responsable.nom} ${item.responsable.prenom}` : '',
          upCount: item.unites_production_count || (item.unites_production ? item.unites_production.length : 0) || 0,
          upNames: item.unites_production ? item.unites_production.map(u => u.nom).join(', ') : '',
          is_active: item.is_active ? 'Actif' : 'Inactif',
        }));
        const formatted = data.map(row => filterVal.map(key => row[key]));
        export_json_to_excel({
          header: tHeader,
          data: formatted,
          filename: 'scoops',
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.downloading = false;
      }
    },
    async fetchSuperviseurs(keyword = '') {
      this.loadingSuperviseurs = true;
      try {
        const params = { keyword, grade_id: 2 };
        const { data } = await controleurResource.list(params);
        this.superviseurs = data || [];
      } finally {
        this.loadingSuperviseurs = false;
      }
    },
    remoteSuperviseurSearch(query) {
      this.fetchSuperviseurs(query);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.card-panel {
  display: flex;
  align-items: center;
}
</style>

